import { firestore as db } from "./firebase";

export const COLLECTION_ACHIEVEMENTS = "achievements";
export const COLLECTION_ACHIEVEMENT_NOTIFICATION = "achievement_notifications";

export const achievementTypes = {
  COMMENTS: "comments",
  FOLLOWS: "follows",
  LIKES: "likes",
  VOTES: "votes",
};

// The Achievement and Achievements types define how the achievements for a user are stored in the Firestore database.
export type Achievement = {
  count: number;
  target: number;
  achieved: boolean;
};

export type Achievements = {
  userId: string;
  comments: Achievement;
  follows: Achievement;
  likes: Achievement;
  votes: Achievement;
};

export type AchievementNotification = {
  name: string;
  hasRead: boolean;
  timestamp: firebase.firestore.Timestamp;
};

export async function getAchievements(
  userId: string
): Promise<Achievements | null> {
  const document = await db
    .collection(COLLECTION_ACHIEVEMENTS)
    .doc(userId)
    .get();

  let achievements = null;
  if (document.exists) achievements = document.data() as any;

  return achievements;
}

export function getAchievementNotification(
  userId: string,
  setAchievementNotification: (
    achievementNotification: AchievementNotification | null
  ) => void
): () => void {
  return db
    .collection(COLLECTION_ACHIEVEMENT_NOTIFICATION)
    .doc(userId)
    .onSnapshot(function (doc) {
      const achievementNotification = doc.data() as any;
      if (achievementNotification && !achievementNotification.hasRead)
        setAchievementNotification(
          achievementNotification ? achievementNotification : null
        );
    });
}

export async function markAchievementNotificationAsRead(userId: string) {
  const batch = db.batch();

  const achievementNotificationRef = db
    .collection(COLLECTION_ACHIEVEMENT_NOTIFICATION)
    .doc(userId);

  batch.set(achievementNotificationRef, { hasRead: true }, { merge: true });

  await batch.commit();
}
